export default function installInit(NetteAjax) {
  return NetteAjax.ext('init', {
    load: function (rh) {
      // handle clicks on link and pass to vue-router
      window.document.body.addEventListener('click', (event) => {
        // ensure we use the link, in case the click has been received by a subelement
        let { target } = event
        while (target && target.tagName !== 'A') target = target.parentNode
        // handle only links that do not reference external resources
        if (!target || !target.matches("a:not([href*='://'])") || !target.href || !target.classList.contains('ajax'))
          return
        // don't handle if `target="_blank"`
        if (target && target.getAttribute) {
          const linkTarget = target.getAttribute('target')
          if (/\b_blank\b/i.test(linkTarget)) return
        }

        rh.call(target, event)
      })
    },
  })
}
